export enum AppConstants {
  USER_DATA = 'USER_DATA',
  ROLES = 'ROLES',
  LANGUAGE = 'LANGUAGE',
}
